import { Query } from '@apollo/client/react/components';
import React from 'react';
import { hospitalRatingStats } from '../../../graph/feedback';
import { get } from 'lodash';
import { StarRating } from '../../entities/feedback/columns';
import { Link as RouterLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Link, Tooltip } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import pick from 'lodash/fp/pick';
import queryString from 'query-string';
import { qsEncode } from '@/se/hocs/withFilterQueryString';

const encodeFilter = qsEncode();

const getFeedbackPath = pathname => {
  const analyticsIndex = pathname.indexOf('/analytics');
  if (analyticsIndex >= 0) {
    return `${pathname.slice(0, analyticsIndex)}/feedback/patient`;
  }
  return pathname;
};

const getFeedbackTo = (pathname, filter) => {
  const pathnameTo = getFeedbackPath(pathname);
  const search = queryString.stringify(
    encodeFilter({
      dateRange: filter?.dateRange,
      physician: filter?.physician,
      physicians: filter?.physicians,
      procedureType: filter?.procedureType,
      speciality: filter?.speciality,
    })
  );
  return search ? { pathname: pathnameTo, search: `?${search}` } : pathnameTo;
};

const useStyles = makeStyles(theme => ({
  inlineTooltip: {
    marginLeft: theme.spacing(1),
  },
  tooltipText: {
    borderBottom: `1px dotted ${theme.palette.divider}`,
  },
  group: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    flexShrink: 0,
  },
}));

export const roundToDecimal = val => (val ? (Math.round(val * 10) / 10).toFixed(1) : val);

const Group = ({ children }) => {
  const classes = useStyles();

  return (
    <Box component={Paper} className={classes.group}>
      {children}
    </Box>
  );
};
const noRatingsTooltip = `
  Make sure the patient leaves their cell phone number at the front desk and they will automatically receive an SMS asking them to rate their experience once the procedure is over.'
`;

export const HospitalRatingWidget = withRouter(({ stats, loading, location, filter }) => {
  const classes = useStyles();
  const feedbackTo = getFeedbackTo(location.pathname, filter);

  if (loading) {
    return (
      <Group>
        <span style={{ height: 24, width: 100 }}> </span>
      </Group>
    );
  }
  if (stats) {
    return (
      <Group isFlex>
        <Link component={RouterLink} to={feedbackTo}>
          {roundToDecimal(stats.averageRating)}
        </Link>
        <Box component={RouterLink} mx={1} to={feedbackTo}>
          <StarRating rating={stats.averageRating} />
        </Box>
        <Tooltip title={`${stats.votes} patients left feedback, total turnout is at ${stats.turnout}%`}>
          <Typography>{`(${stats.votes} / ${stats.turnout}%)`}</Typography>
        </Tooltip>
      </Group>
    );
  }
  return (
    <Box flexShrink={0}>
      <Alert severity="info">
        No patient ratings yet.
        <Tooltip title={noRatingsTooltip} className={classes.inlineTooltip}>
          <span className={classes.tooltipText}>How to invite patients to leave feedback?</span>
        </Tooltip>
      </Alert>
    </Box>
  );
});

const pickFilter = pick([
  'name',
  'physician',
  'procedureType',
  'hospital',
  'status',
  'dateRange',
  'category',
  'speciality',
]);

export default ({ filter }) => {
  const { dateRange, physicians, ...rest } = filter || {};
  return (
    <Query
      query={hospitalRatingStats}
      variables={{ filter: { dateRange: dateRange.toJSON(), physicians, ...pickFilter(rest) } }}
      fetchPolicy="network-only"
    >
      {({ loading, data = {} }) =>
        data ? (
          <HospitalRatingWidget stats={get(data, 'hospitalRatingStats')} loading={loading} filter={filter} />
        ) : undefined
      }
    </Query>
  );
};
